import axios from "axios";
import Vue from 'vue';
import store from './store';
import {
	MessageBox,
	Message
} from 'element-ui';
import router from '@/router';

// 接口路径
const baseURL = store.state.baseURL;


let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (ever) => {
	for(let p in pending){
		if(pending[p].u === ever.url + '&' + ever.method) { //当当前请求在数组中存在时执行函数体
			pending[p].f(); //执行取消操作
			pending.splice(p, 1); //把这条记录从数组中移除
		}
	}
}

/****** 创建axios实例 ******/
const service = axios.create({
	baseURL: baseURL, // api的base_url
	timeout: 3000, // 请求超时时间
	withCredentials: true, //
});
/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {
	// 判断token状态
	var token = localStorage.getItem('token');
	// 没有token跳转登录页
	if (!token) {
		checkShare();
		return Promise.reject('该页面需要登录');
	}
	// 设置请求头token
	config.headers['Authorization'] = "Bearer " + token;

	//-----------------------------------------------------------------------------------------
	removePending(config); //在一个ajax发送前执行一下取消操作
	config.cancelToken = new cancelToken((c)=>{
		//这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
		pending.push({ u: config.url + '&' + config.method, f: c });
	});
	//-----------------------------------------------------------------------------------------

	return config;
}, error => { //请求错误处理
	console.log(error);
	return Promise.reject(error);
});

function checkShare() {
  var path = window.location.href.split('#/')[1];
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  router.push({
  	path: '/',
  	// query: {
  	// 	path: path,
  	// }
  });
  window.location.reload();
};

/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
	res => { //成功请求到数据
		// ------------------------------------------------------------------------------------------
		removePending(res.config);  //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
		// -------------------------------------------------------------------------------------------
		if (res.status == 200) {
			if (res.data.code == 500) { // 报错
				Message.error(res.data.message);
        checkShare();
				return Promise.reject(res.data.message);
			} else if (res.data.code == 401) {
				// token有误
				checkShare();
				return Promise.reject(res.data.message);
			} else if (res.data.code == 501) { // token过期
				console.log(res.data.message)
				if (!localStorage.getItem('refreshToken')) {
					checkShare();
					return Promise.reject('登录信息有误');
				}
				var config = res.config;
				return new Promise((resolve, reject) => {
					// 请求刷新token
					axios.get(baseURL + '/auth/douniuapp/refresh/' + localStorage.getItem('refreshToken'))
						.then((response) => {
							if (response.data.code == 200) {
								// 修改token
								config.headers['Authorization'] = "Bearer " + response.data.data.token;
								// store.commit("SET_TOKEN", response.data.data.token);
								// store.commit("SET_REFRESH_TOKEN", response.data.data.refreshToken);
				        localStorage.setItem('token',response.data.data.token);
				        localStorage.setItem('refreshToken',response.data.data.refreshToken);
								return axios(config).then(resp => {
									return resolve(resp);
								})
							} else {
								console.log("denglu2");
								// 刷新token报错跳转登录页
								checkShare();
								return reject(response.data.message);
							}
						})
						.catch((error) => {
							// 刷新token报错跳转登录页
							checkShare();
							return reject(error);
						})
				});
			} else if (res.data.code == 200) { //正常
				return res;
			}
		} else {
			return Promise.reject(res);
		}
	},
	error => { //响应错误处理
		return Promise.reject(error);
	}
);

// 登录service(不带token)
const loginService = axios.create({
	baseURL: baseURL, // api的base_url
	timeout: 5000, // 请求超时时间
	withCredentials: true, //
});
/****** request拦截器==>对请求参数做处理 ******/
loginService.interceptors.request.use(config => {
	// console.log(config);
	// 删除请求头token信息
	delete config.headers['Authorization'];
	return config;
}, error => { //请求错误处理
	console.log(error)
});
/****** respone拦截器==>对响应做处理 ******/
loginService.interceptors.response.use(
	res => { //成功请求到数据
		if (res.status == 200) {
			if (res.data.code == 500) {
				// $('body').toast({
				//   content: res.data.message,
				// });
				return Promise.reject(res.data.message);
			}
			return res;
		} else {
			return Promise.reject(res);
		}
	},
	error => { //响应错误处理
		return Promise.reject(error)
	}
);

// 登录service(不带token)
const authCodeLoginService = axios.create({
	baseURL: baseURL, // api的base_url
	timeout: 5000, // 请求超时时间
	withCredentials: true, //
});

authCodeLoginService.interceptors.request.use(config => {
	// console.log(config);
	// 删除请求头token信息
	delete config.headers['Authorization'];
	return config;
}, error => { //请求错误处理
	console.log(error)
});
/****** respone拦截器==>对响应做处理 ******/
authCodeLoginService.interceptors.response.use(
	res => { //成功请求到数据
		if (res.status == 200) {
			if (res.data.code == 500) {
				// $('body').toast({
				//   content: res.data.message,
				// });

				return Promise.reject(res.data.message);
			}
			return res;
		} else {
			return Promise.reject(res);
		}
	},
	error => { //响应错误处理
		return Promise.reject(error)
	}
);

export default {
	service,
	loginService,
	authCodeLoginService
};



// WEBPACK FOOTER //
// ./src/utils/request.js